import React, { Component, Fragment } from 'react';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} imageName
 * @prop {String} href
 *
 * @augments {Component<Props>}
 */
export default class ClientTile extends Component {

	render () {
		const { imageName, href } = this.props;
		const imageUrl = require(`../../../assets/images/clients/${imageName}`);
		const img = <img alt={`Client ${imageName}`} src={imageUrl} />;
		return (
			<Fragment>
				{href ? <a className='ClientTile' href={href}>{img}</a> : <div className='ClientTile'>{img}</div>}
			</Fragment>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/ClientTile/ClientTile.js